import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Nav, Navbar } from "react-bootstrap";

function Header() {
  useEffect(() => {
    $("a[href^='#']").click(function (e) {
      e.preventDefault();
      var position = $($(this).attr("href")).offset().top;
      $("body, html").animate(
        {
          scrollTop: position - 80,
        },
        700
      );
    });
    $(window).scroll(function () {
      if ($(this).scrollTop()) {
        $("nav").addClass("navbar-scroll bg-light animated fadeIn shadow");
      } else {
        $("nav").removeClass("navbar-scroll bg-light animated fadeOut shadow");
      }
    });
    return () => {
      $("a[href^='#']").off("click");
      $(window).off("scroll");
    };
  }, []);

  const [navExpanded, setNavExpanded] = useState(false);

  return (
    <div>
      <div className="home-header-parent" id="home">
        <div className="header home-header">
          <Navbar
            bg="light"
            expand="lg"
            className="position-fixed"
            expanded={navExpanded}
          >
            <Navbar.Brand
              href="#home"
              className="ml-auto text-danger d-none  d-lg-inline d-md-inline"
              onClick={() => {
                setNavExpanded(false);
              }}
            >
              VEG TIFFIN
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="mx-2"
              onClick={() => {
                navExpanded ? setNavExpanded(false) : setNavExpanded(true);
              }}
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link
                  href="#home"
                  onClick={() => {
                    setNavExpanded(false);
                  }}
                >
                  <li className="nav-item">HOME</li>
                </Nav.Link>
                <Nav.Link
                  href="#menu"
                  onClick={() => {
                    setNavExpanded(false);
                  }}
                >
                  <li className="nav-item">MENU</li>
                </Nav.Link>
                <Nav.Link href="./order/online">
                  <li className="nav-item"> ORDER ONLINE</li>
                </Nav.Link>
                <Nav.Link
                  href="#contact"
                  onClick={() => {
                    setNavExpanded(false);
                  }}
                >
                  <li className="nav-item">CONTACT</li>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
            <Navbar.Brand
              href="#home"
              className="ml-auto text-danger d-md-none d-lg-none"
              onClick={() => {
                setNavExpanded(false);
              }}
            >
              VEG TIFFIN
            </Navbar.Brand>
          </Navbar>

          <div className="container">
            <div className="row home-cover-title">
              <div className="col-12 col-md-6 offset-md-1 offset-lg-1 col-lg-6">
                <h1>VEG TIFFIN</h1>
                <p className="py-3">
                  Healthy, Honest-To-Goodness, Homestyle Food delivered right to
                  your doorstep!
                </p>
                <a className="btn btn-simple-button my-3" href="#menu">
                  VIEW THE MENU
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
